import Signal from "signals";
import { get, writable } from "svelte/store";
import InputHelper from "../Helpers/InputHelper";
import MapStore from "../Map/Store";
import AircraftProperty from "../Models/Enums/AircraftProperty";
import VesselProperty from "../Models/Enums/VesselProperty";
import InfoCardStore from "../UI/InfoCard/Store";
import TimeSliderData from "../UI/TimeSlider/TimeSliderData";

class VesselGroup {
	constructor() {
		this.id = VesselGroup.idCounter++;
		this.onSelectionChanged = new Signal();
		this.onFocusedChanged = new Signal();

		// TimeSlider component instance.
		this.timeSlider = null;
		this.timeSliderData = new TimeSliderData();

		this.vessels = writable([]);
		this.uniqidType = VesselProperty.IMO;
		this.selected = {
			[VesselProperty.IMO]: writable([]),
			[VesselProperty.MMSI]: writable([]),
			[VesselProperty.SPIRE_ID]: writable([]),
			[AircraftProperty.REGISTRATION]: writable([]),
			[AircraftProperty.ICAO_ADDRESS]: writable([])
		};
		this.focused = {
			[VesselProperty.IMO]: writable([]),
			[VesselProperty.MMSI]: writable([]),
			[VesselProperty.SPIRE_ID]: writable([]),
			[AircraftProperty.REGISTRATION]: writable([]),
			[AircraftProperty.ICAO_ADDRESS]: writable([])
		};
		this.visible = writable(true);
		this.lastUpdated = writable(Date.now());

		this.visible.subscribe(() => {
			this.lastUpdated.set(Date.now());
		});
		// TODO:
		// 	Lots to do here, but mostly we want Vessels to belong to a group because...
		//	* We don't want to refer to a (global) Alerts time slider value,
		// 	  or to a Vessel History time slider value, etc.
		//  * We don't want to duplicate code for findByIMO/findBySpireID/findByMMSI, etc.
		//  * More will come later.
		// this.vessels = [];

		const focusChangeImpl = () => {
			const focusedVessels = get(this.vessels).filter((vessel) => {
				return vessel.focused;
			});
			this.onFocusedChanged.dispatch(focusedVessels);
		};
		this.focused[VesselProperty.IMO].subscribe(focusChangeImpl);
		this.focused[VesselProperty.MMSI].subscribe(focusChangeImpl);
		this.focused[VesselProperty.SPIRE_ID].subscribe(focusChangeImpl);
		this.focused[AircraftProperty.REGISTRATION].subscribe(focusChangeImpl);
		this.focused[AircraftProperty.ICAO_ADDRESS].subscribe(focusChangeImpl);
	}

	/*
	 * map: Mapbox Map
	 * layers: MapLayer[]
	 * findParams: string[] - property list of Vessel model to search for features by in the layers.
	 */
	selectSingle(map, event, layers = [], findParams = []) {
		if (!InputHelper.isCtrlKeyDown()) {
			this.deselectAll();
		}

		const features = map.queryRenderedFeatures(event.point, {
			layers: layers
		});
		if (features.length) {
			const feature = features[0];
			console.log("feature", feature);

			const findObj = {};
			for (let i = 0; i < findParams.length; i++) {
				const property = findParams[i];
				findObj[property] = feature.properties[property];
			}
			const vessel = this.find(findObj);
			console.log("vessel", vessel);
			if (vessel) {
				vessel.selected = !vessel.selected;
				if (vessel.selected) {
					console.log("vessel.hasactivesnapshot", vessel.hasActiveSnapshot());
					console.log("vessel.currentCoordinates", vessel.currentCoordinates);
					MapStore.helpers.moveToPoint(vessel.currentCoordinates);
					InfoCardStore.actions.setModel(vessel);
					MapStore.helpers.zoomToPoint(vessel.currentCoordinates);
				}
				if (this.countSelected() === 0) {
					InfoCardStore.actions.close();
				}
				this.update();
			}
		}
	}

	selectSingleVessel(newVessel) {
		this.deselectAll();
		this.unfocusAll();
		newVessel.selected = true;
		newVessel.focused = true;
		MapStore.helpers.moveToPoint(newVessel.currentCoordinates);
		MapStore.helpers.zoomToPoint(newVessel.currentCoordinates);
		InfoCardStore.actions.setModel(newVessel);
		this.update();
	}

	find(params, verbose = true) {
		const keys = Object.keys(params);
		const vessels = get(this.vessels);
		for (let i = 0; i < vessels.length; i++) {
			const vessel = vessels[i];
			let match = true;
			for (let j = 0; j < keys.length; j++) {
				const key = keys[j];
				if (vessel[key] !== params[key]) {
					match = false;
					break;
				}
			}
			if (match) {
				return vessel;
			}
		}
		if (verbose) {
			console.warn("could not find vessel in vesselgroup", this.id, "with params", params, vessels);
		}
		return false;
	}

	filter(filterFunction, verbose = true) {
		const results = [];
		const vessels = get(this.vessels);
		for (let i = 0; i < vessels.length; i++) {
			const vessel = vessels[i];
			if (filterFunction(vessel)) {
				results.push(vessel);
			}
		}
		return results;
	}

	countSelected() {
		// TODO: consider this.selected[VesselProperty.IMO]).length;
		// We would need to add the "uniqidType" property to the group.
		let count = 0;
		const vessels = get(this.vessels);
		for (let i = 0; i < vessels.length; i++) {
			if (vessels[i].selected) {
				count++;
			}
		}
		return count;
	}

	update() {
		this.vessels.update(value => value); // Trigger update
		this.lastUpdated.set(Date.now());
	}

	setPropertyAll(property, value) {
		const vessels = get(this.vessels);
		for (let i = 0; i < vessels.length; i++) {
			vessels[i][property] = value;
		}
	}

	containsProperty(property, value) {
		const vessels = get(this.vessels);
		return (vessels.findIndex(vessel => "" + vessel[property] === "" + value) > -1);
	}

	unfocusAll() {
		this.setPropertyAll("focused", false);
	}

	unselectAll() {
		this.deselectAll();
	}

	deselectAll() {
		this.setPropertyAll("selected", false);
	}
}
VesselGroup.idCounter = 0;
export default VesselGroup;
